import React from 'react'
import one from './imgg/one.jpg'
import two from './imgg/two.jpg'
import three from './imgg/three.jpg'
import four from './imgg/four.jpg'
import five from './imgg/five.png'
import six from './imgg/six.jpg'
import seven from './imgg/seven.jpg'
import eight from './imgg/eight.jpg'
import nine from './imgg/nine.jpg'
import ten from './imgg/ten.jpg'
import eleven from './imgg/eleven.jpg'
import twelve from './imgg/twelve.jpg'
import thirteen from './imgg/thirteen.jpg'
import fourteen from './imgg/fourteen.jpg'
import fifteen from './imgg/fifteen.jpg'
import real1 from './imgg/real1.jpg'
import real2 from './imgg/real2.jpg'
import real3 from './imgg/real3.jpg'
import real4 from './imgg/real4.jpg'
import real5 from './imgg/real5.jpg'
import real6 from './imgg/real6.jpg'
import real7 from './imgg/real7.jpg'
import {
    Link
  } from "react-router-dom";



export default function Vehicles() {
    return (
        <div>
            <section class="team">
                <div class="section-header">
                    <h1 class="section-heading">Our Vehicles</h1>
                    <div class="underline"></div>
                </div>
                <div class="cards-wrapper2">
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={one} alt="CEO" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real1} alt="CEO" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                    <img src={two} alt="Designer" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                    <img src={real2} alt="Designer" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={three} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real3} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={four} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real4} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={five} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real5} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={six} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real6} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={seven} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={real7} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={eight} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={nine} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={fifteen} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={fourteen} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={ten} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={eleven} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={twelve} alt="Architect" />
                    </div>
                </div>
                <div class="card2">
                    <div class="card-img-wrapper">
                        <img src={thirteen} alt="Architect" />
                    </div>
                </div>
                </div>
            </section>
            <Link to="/">
                <div class=' wahala'>
                    <button>Home Page</button>
                </div>
                
            </Link>
        </div>
    )
}
